module.exports = __webpack_public_path__ + "img/6.1e9acff6.png";